
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "EHRAscore",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/EHRAscore.vue